module.exports = __webpack_public_path__ + "img/black_board_a001_title.c7ecb256.png";